import { inputAndDiscussPinPhases, QuizView } from '../../playerStore.types';
import { PlayerPinReducer, PlayerPinReducerFactory } from '../reducers.types';
import { nextPhase } from '../reducers.utils';

export type QuizReducer = PlayerPinReducer<QuizView>;

export const createQuizReducer: PlayerPinReducerFactory<QuizView> = () => quizReducer;

export const quizReducer: QuizReducer = {
  phases: inputAndDiscussPinPhases,
  initial: () => {
    return {
      type: 'MULTIPLE_CHOICE',
      phase: 'input',
    };
  },
  hasNextView: (state, currentView, direction) => {
    return nextPhase(currentView.phase, quizReducer.phases, direction) !== null;
  },
  handleNextView: (state, prev, direction) => {
    if (!prev) {
      return false;
    }

    const next = nextPhase(prev.phase, quizReducer.phases, direction);
    if (next) {
      return {
        type: 'MULTIPLE_CHOICE',
        phase: next,
      };
    }
    return false;
  },
  onNextView: async (state, prev, next, services, setBackgroundActionAction) => {
    if (prev.phase === 'input') {
      const action = () => services.apiService.quiz.checkPinStudentAnswers(state.currentPinId);
      setBackgroundActionAction?.(action);
      return action();
    }
    return null;
  },
};
